import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCurrentUser } from "./redux/regionsSagas";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { Add } from "./smartComponents/Add";
import { Edit } from "./smartComponents/Edit";
import { Delete } from "./smartComponents/Delete";
import { SetAsDefault } from "./smartComponents/SetAsDefault";
import { Trash, Edit as EditIcon } from "../../../assets/images/svg";
import { usePopup } from "./hooks/usePopup";
import "./regions.scss";

export function RegionsModule({ params }) {
  const dispatch = useDispatch();

  const regions = useSelector((state) => state.regions.regions);
  const locations = useSelector((state) => state.regions.locations);
  const isLoading = useSelector((state) => state.regions.isLoading);

  const [selectedRegion, setSelectedRegion] = useState("");

  const { popup, openPopup, closePopup } = usePopup();

  const handlePopup = (id, type) => {
    setSelectedRegion(regions.find((region) => region.id == id));

    openPopup(type);
  };

  useEffect(() => {
    dispatch(fetchCurrentUser(params));
  }, []);

  if (isLoading)
    return (
      <div className="light">
        <LoadingAnimation />
      </div>
    );

  return (
    <div className="regions">
      <div className="regions__add">
        <button onClick={() => openPopup("add")} className="button button--primary">
          Add Region
        </button>
      </div>

      <div className="regions__content">
        <ul className="group">
          {regions.map(({ id, name, location_ids, isDefault }) => {
            const count = location_ids.length;
            const isActiveDeleteButton = count === 0 && !isDefault;
            return (
              <li color="dark" className="group__item" key={id + name}>
                <div className="group__el text">{`${name} ${
                  isDefault ? "(Default Region)" : ""
                } - Locations: ${count}`}</div>

                {!isDefault && (
                  <div className="group__el ">
                    <button
                      className="button button--secondary"
                      onClick={() => handlePopup(id, "default")}
                    >
                      Set as Default
                    </button>
                  </div>
                )}

                <div className="group__el ">
                  <span
                    className="group__icon"
                    onClick={() => handlePopup(id, "edit")}
                    title="Edit Region"
                  >
                    <EditIcon />
                  </span>
                </div>

                <div className="group__el delete">
                  <span
                    className="group__icon"
                    onClick={() => (isActiveDeleteButton ? handlePopup(id, "delete") : null)}
                    title="Delete"
                  >
                    <Trash color={isActiveDeleteButton ? "#FF0000" : "#dea4a4"} />
                  </span>
                </div>
              </li>
            );
          })}
        </ul>
      </div>

      <SetAsDefault
        isOpen={popup.default}
        onClose={closePopup("default")}
        selectedRegion={selectedRegion}
      />

      {popup.add && <Add isOpen={popup.add} onClose={closePopup("add")} locations={locations} />}

      {popup.edit && (
        <Edit
          isOpen={popup.edit}
          onClose={closePopup("edit")}
          selectedRegion={selectedRegion}
          locations={locations}
        />
      )}

      <Delete
        isOpen={popup.delete}
        onClose={closePopup("delete")}
        selectedRegion={selectedRegion}
      />
    </div>
  );
}
